// Axios instance for the Super Admin portal. Uses its own cookie/session
// (sa_session), fully independent from the tenant workspace's `eip_session`.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SA_API = `${BACKEND_URL}/api/superadmin`;

function readCookie(name) {
  const parts = (document.cookie || "").split(";");
  for (const p of parts) {
    const [k, ...rest] = p.trim().split("=");
    if (k === name) return decodeURIComponent(rest.join("="));
  }
  return null;
}

const saApi = axios.create({ baseURL: SA_API, withCredentials: true });

// Same CSRF pattern as the tenant api — echo eip_csrf as X-CSRF-Token.
saApi.interceptors.request.use((cfg) => {
  const method = (cfg.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const tok = readCookie("eip_csrf");
    if (tok) {
      cfg.headers = cfg.headers || {};
      cfg.headers["X-CSRF-Token"] = tok;
    }
  }
  return cfg;
});

saApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const p = window.location.pathname;
      const url = String(err?.config?.url || "");
      const isLoginCall = url.includes("/auth/login") || url.includes("/auth/me");
      if (!isLoginCall && p.startsWith("/superadmin") && !p.startsWith("/superadmin/login")) {
        window.location.href = "/superadmin/login";
      }
    }
    return Promise.reject(err);
  },
);

export default saApi;
